import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConnectionService } from './connection.service';
import { ConfigService } from './endpoint.config.service';





@Injectable({
    providedIn: 'root'
})
export class TableService extends ConnectionService {

    constructor(http: HttpClient, private configs: ConfigService) {
        super(http);
    }

    fetchData(endPoint, sucFun, errFun, param) {
        var currentLocationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
        endPoint = this.configs.getAppApiUrl(endPoint).replace('{{currentLocationId}}', currentLocationId);
        this.CallApi("get", endPoint, param, null, (res) => {
            var resp = JSON.parse(JSON.stringify(res))
            sucFun(resp)
        }, (err) => { errFun(err) })

    }
    getRow(endPoint, userLocationId, sucFun, errFun) {
        var locationId = JSON.parse(sessionStorage.getItem("company")).UserLocationId;
        endPoint = this.configs.getAppApiUrl(endPoint).replace('{{currentLocationId}}', locationId).replace('{{currentLocationId}}', userLocationId);
        this.CallApi("get", endPoint, {}, null, (res) => {
            var resp = JSON.parse(JSON.stringify(res))
            sucFun(resp)
        }, (err) => {
            errFun(err)
        })
    }
    

}
